<template>
	<ListItem
		is-recipient
		:custom-text="text"
	/>
</template>
<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";

export default {
	components: {
		ListItem
	},

	computed: {
		text ()
		{
			let text = '<div class="font-weight-bold">Jetzt bist du wieder dran! Was willst du tun?</div>';
			text += '<div>Lade die Person zu einem Gespräch ein oder mache dir ein Telefonat mit ihr aus oder frag nach einem Lebenslauf.</div>';

			return text;
		}
	}
}
</script>
